import React from 'react';
import {Box, Button, Typography} from '@mui/material';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import {useTranslation} from 'react-i18next';

interface HiddenRowCardProps {
    rowKey: string;
    /** The admin's name for the row (rowLabel); the row key when absent. */
    label?: string;
    /** What the user filled in it (rowSummary) — kept while hidden. */
    summary: string;
    onShow: (key: string) => void;
}

/** A row the user took out of the design: dashed and muted, one tap to bring it back. */
const HiddenRowCard: React.FC<HiddenRowCardProps> = ({rowKey, label = rowKey, summary, onShow}) => {
    const {t} = useTranslation();
    return (
        <Box sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.25,
            border: '1px dashed #ffffff35',
            borderRadius: '14px',
            px: 1.5,
            py: 1.25,
            mb: 1,
            color: '#8aa6ba',
        }}>
            <VisibilityOffOutlinedIcon fontSize="small"/>
            <Typography dir="auto" noWrap sx={{flexGrow: 1, minWidth: 0, fontSize: '0.88rem'}}>
                {summary ? `${label} · ${summary}` : label}
            </Typography>
            <Button
                size="small"
                onClick={() => onShow(rowKey)}
                data-testid={`row-show-${rowKey}`}
                sx={{color: '#C3F3FD', fontWeight: 600, textTransform: 'none', minWidth: 0}}
            >
                {t('editor.rows.show')}
            </Button>
        </Box>
    );
};

export default HiddenRowCard;
